import React, { useEffect, useState } from "react";
import apiRequest from "../../../utils/ApiRequest/apiRequest.js";
import GetTransformedDate from "../../../utils/dateViewTransformer.tsx";
import useMediaQueries from "../../../hooks/useMediaQueries.js";
import Icon from "../../Elements/Icon/Icon.tsx";
import Tooltip from "../../Elements/Tooltip/Tooltip.js";
import Dropdown from "../../Elements/Dropdown/Dropdown.js";
import LoadingImageElement from "components/Elements/LoadingContainerElement/LoadingImageElement.tsx";
import { useContent } from "../../../contexts/contentContext/contentContext.js";
import { useMail } from "../../../contexts/mailContext/mailContext.js";
import { useUser } from "../../../contexts/userContext/userContext.js";
import { LinkToNewTab } from "../../Elements/Link/Link.js";
import { Toggle } from "components/Elements/Toggle/Toggle.js";
import { useModal } from "contexts/modalContext/modalContext.js";
import { LogModal } from "components/Pages/Inbox/Embed/LogModal.js";

const FtpLogSuggestion = ({ deliveryNumber }) => {
  const { getTextByKey } = useContent();
  const { setModal } = useModal();

  const hanleClick = () => {
    setModal({
      modal: LogModal,
      props: { deliveryNumber: deliveryNumber, ftpDefault: true },
    });
  };
  return (
    <span className="ftp-log-suggestion-text" onClick={hanleClick}>
      {getTextByKey("no-records-open-ftp-log")}
    </span>
  );
};

const SingleDataRecord = ({ data, freeUser }) => {
  const { getTextByKey } = useContent();
  const { desktopCondition, newMobileCondition } = useMediaQueries();
  const [showAll, setShowAll] = useState(desktopCondition);
  const handleChange = () => {};
  const testData = { ...data };
  let fileNameLog = "";
  if (testData.downloadType === "FavoritesDownload") {
    if (testData.FileName) {
      let listNames = testData.FileName.split(",");
      let fixList = listNames.slice(0, listNames.length - 1);
      fileNameLog = (
        <div className="favorites-list-names">
          <Dropdown handleChange={handleChange} selectList={fixList}>
            {getTextByKey("download-logs-selected-files")}
            <Icon small name="arrow-down-solid" />
          </Dropdown>
        </div>
      );
    }
  } else if (testData.downloadType === "ZipDownload") {
    fileNameLog = "ZIP";
  } else {
    fileNameLog = (
      <Tooltip
        id={"download-log"}
        tooltipTextKey={data["FileName"]}
        //hardPositioned
      >
        {data["FileName"]}
      </Tooltip>
    );
  }
  return (
    <div className="single-item">
      <div className="user-id-part">
        <p>{getTextByKey("user-id-downloads-log")}</p>
        <span>{data["UserName"] || "anonymous"}</span>
      </div>
      <div className="date-part">
        <p>{getTextByKey("date-time-downloads-log")}</p>
        <span>
          <GetTransformedDate date={data["Date"]} showTime={true} />
        </span>
      </div>
      {showAll ? (
        <>
          <div className="ip-address">
            <p>{getTextByKey("ip-address-downloads-log")}</p>
            <span>
              {!freeUser
                ? data["ipAddress"]
                : getTextByKey("only-subscribers-downloads-log")}
            </span>
          </div>
          <div className="download-status">
            <p>{getTextByKey("file-downloads-status")}</p>
            <span>{getTextByKey(data["DownloadStatus"])}</span>
          </div>
          <div className="download-type">
            <p>{getTextByKey("file-downloads-log")}</p>
            <span>{fileNameLog}</span>
          </div>
        </>
      ) : null}
      {newMobileCondition ? (
        <div
          className={`show-all-info${showAll ? " open" : ""}`}
          onClick={() => setShowAll((prev) => !prev)}
        >
          <Icon name={`arrow-${showAll ? "up" : "down"}`} gray />
        </div>
      ) : null}
    </div>
  );
};

const DataRecordElem = ({ data, index, freeUser }) => {
  const { getTextByKey } = useContent();
  const handleChange = () => {};
  const isDivisible = index % 2 === 0;
  const classNames = `action-item${!isDivisible ? "" : " gray-background"}`;
  const testData = { ...data };
  let fileNameLog = "";
  if (testData.downloadType === "FavoritesDownload") {
    if (testData.FileName) {
      let listNames = testData.FileName.split(",");
      let fixList = listNames.slice(0, listNames.length - 1);
      fileNameLog = () => (
        <div className="favorites-list-names">
          <Dropdown handleChange={handleChange} selectList={fixList}>
            {getTextByKey("download-logs-selected-files")}
            <Icon small name="arrow-down-solid" />
          </Dropdown>
        </div>
      );
    }
  } else if (testData.downloadType === "ZipDownload") {
    fileNameLog = () => "ZIP";
  } else {
    fileNameLog = () => (
      <Tooltip id={"download-log"} tooltipText={data["FileName"]}>
        {data["FileName"]}
      </Tooltip>
    );
  }
  return (
    <div className={classNames}>
      <div className="date-part">
        <GetTransformedDate date={data["Date"]} showTime={true} />
      </div>
      <div className="user-id-part">{data["UserName"] || "anonymous"}</div>
      <div className="ip-address">
        {!freeUser
          ? data["ipAddress"]
          : index === 0
          ? getTextByKey("only-subscribers-downloads-log")
          : "-"}
      </div>
      <div className="download-status">
        {getTextByKey(data["DownloadStatus"])}
      </div>
      <div className="download-type">{fileNameLog()}</div>
    </div>
  );
};

export const DownloadLogModal = ({ mailData }) => {
  const { getTextByKey, getDirection } = useContent();
  const { newMobileCondition } = useMediaQueries();
  const { getMailId, getMailMetaData } = useMail();
  const { isLoggedIn, isSubscribed } = useUser();
  const [loading, setLoading] = useState(true);
  const [fethcedData, setFetchedData] = useState([]);
  const [numToDisplay, setNumToDisplay] = useState(2);
  const mailMetaData = mailData ? mailData : getMailMetaData();
  const mailId = mailData ? mailData.id : getMailId();

  const donwloadsCount =
    mailMetaData.DownloadsCount || mailMetaData.downloadsQuantity;

  const [totalLogs, setTotalLogs] = useState(null);
  const [page, setPage] = useState(1);
  const [searchString, setSearchString] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const [isUnique, setIsUnique] = useState(false);

  const increasePage = () => {
    if (page * 10 < totalLogs) {
      setPage((prev) => prev + 1);
    }
  };

  const decreasePage = () => {
    if (page > 1) {
      setPage((prev) => prev - 1);
    }
  };
  const handleChange = (e) => {
    e.preventDefault();
    setSearchValue(e.target.value);
  };

  const handleSubmit = (e, clear) => {
    e.preventDefault();
    const string = searchValue.trim();
    if (string.length > 2 && !clear) {
      setSearchString(string);
    } else {
      setSearchString(null);
    }
    if (page !== 1) {
      setPage(1);
    }
  };

  const handleUnique = () => {
    setIsUnique((prev) => !prev);
    setPage(1);
  };

  const getFetch = async () => {
    setLoading(true);
    const res = await apiRequest(
      "Mails",
      "ReactGetFullDownloadLog",
      {
        encryptedMailId: mailId,
        pageNumber: page,
        numberOfItems: 10,
        searchString: searchString,
        uniqueOnly: isUnique,
      },
      "POST"
    );
    if (res.status === "success") {
      if (res.data) {
        const sortedResponse = res.data.logs.sort((a, b) => {
          const dateA = new Date(a.Date);
          const dateB = new Date(b.Date);
          return dateB - dateA;
        });
        setFetchedData(sortedResponse);
        setTotalLogs(res.data.totalLogs);
        if (isSubscribed()) {
          setNumToDisplay(res.data.length);
        } else {
          setNumToDisplay(2);
        }
      }
    }
    setLoading(false);
  };

  useEffect(() => {
    if (isLoggedIn()) {
      getFetch();
    }
  }, [page, searchString, isUnique, mailId]);

  const replaceFreeUsersText = (str) => {
    let temp = str;

    if (str.includes("#x#")) {
      const num = donwloadsCount - numToDisplay;
      temp = temp.replace("#x#", num);
    }

    return temp;
  };

  const getLogsCount = () => {
    if (totalLogs === null) return null;
    if (totalLogs <= 10) {
      return `${totalLogs} ${getTextByKey("of-text")} ${totalLogs}`;
    } else if (page === 1) {
      return `1-10 ${getTextByKey("of-text")} ${totalLogs}`;
    } else if (page === Math.ceil(totalLogs / 10)) {
      return `${(page - 1) * 10 + 1}-${totalLogs} ${getTextByKey(
        "of-text"
      )} ${totalLogs}`;
    } else {
      return `${(page - 1) * 10 + 1}-${page * 10} ${getTextByKey(
        "of-text"
      )} ${totalLogs}`;
    }
  };

  return (
    <div className="log-modal-wrapper download-log-modal">
      {loading ? (
        <div className="loader-wrapper">
          <LoadingImageElement />
        </div>
      ) : (
        <>
          <div className="log-header">
            <div className="log-title">
              {getTextByKey("downloads-log-title")}
              <div className="log-count">{totalLogs}</div>
            </div>
            <div className="log-tools">
              {isSubscribed() && (
                <div className="log-distinct">
                  {getTextByKey("download-logs-distinct-only")}
                  <Toggle status={isUnique} setStatus={handleUnique} />
                </div>
              )}
              <div className="log-search">
                <form onSubmit={handleSubmit}>
                  <input
                    type=""
                    value={searchValue}
                    onChange={handleChange}
                    placeholder={getTextByKey(
                      "download-logs-search-placeholder"
                    )}
                  />
                </form>
                <div className="search-submit" onClick={handleSubmit}>
                  <Tooltip
                    id={"searchSubmit"}
                    tooltipTextKey={"search-button-tooltip"}
                    bottom
                  >
                    <Icon name="search" white />
                  </Tooltip>
                </div>
              </div>
              {searchValue.length > 0 ? (
                <div
                  className="clear-button"
                  onClick={(e) => {
                    setSearchValue("");
                    handleSubmit(e, "clear");
                  }}
                >
                  <Tooltip
                    id={"searchClear"}
                    tooltipTextKey={"clear-search-button-tooltip"}
                    bottom
                  >
                    <Icon name="x" blue />
                  </Tooltip>
                </div>
              ) : null}
            </div>
          </div>
          <div className="data-container">
            {fethcedData.length === 0 ? (
              <div className="empty-log-message">
                {getTextByKey(`no-records`)}
              </div>
            ) : fethcedData.length === 1 ? (
              <SingleDataRecord data={fethcedData[0]} />
            ) : (
              <>
                {!newMobileCondition ? (
                  <div className="data-headers">
                    <div className="date-part">
                      {getTextByKey("date-time-downloads-log")}
                    </div>
                    <div className="user-id-part">
                      {getTextByKey("user-id-downloads-log")}
                    </div>
                    <div className="ip-address">
                      {getTextByKey("ip-address-downloads-log")}
                    </div>
                    <div className="download-status">
                      {getTextByKey("file-downloads-status")}
                    </div>
                    <div className="download-type">
                      {getTextByKey("file-downloads-log")}
                    </div>
                  </div>
                ) : null}
                {fethcedData.slice(0, numToDisplay).map((item, i) => {
                  return !newMobileCondition ? (
                    <DataRecordElem
                      freeUser={!isSubscribed()}
                      key={item.DownloadId}
                      index={i}
                      data={item}
                    />
                  ) : (
                    <SingleDataRecord
                      freeUser={!isSubscribed()}
                      data={item}
                      key={item.DownloadId}
                    />
                  );
                })}
              </>
            )}
            {!isSubscribed() && (
              <div className="subscribers-limit-details">
                {donwloadsCount > numToDisplay ? (
                  <p>
                    {replaceFreeUsersText(
                      getTextByKey("downloads-log-limit-free-text")
                    )}
                  </p>
                ) : null}
                <p>
                  {getTextByKey("downloads-log-limit-free-text2")}{" "}
                  <LinkToNewTab page={"subscribers"} className="link">
                    {getTextByKey("downloads-log-link-plans")}
                  </LinkToNewTab>
                </p>
              </div>
            )}
          </div>
          <div className="log-footer">
            {totalLogs < donwloadsCount && mailMetaData.deliveryNumber ? (
              <>
                <FtpLogSuggestion
                  deliveryNumber={mailMetaData.deliveryNumber}
                />
                <div className="flex-spacer" />
              </>
            ) : null}
            <div className="log-count">
              {isSubscribed() ? getLogsCount() : null}
            </div>
            {totalLogs > 10 ? (
              <div className="log-paging">
                <Tooltip
                  id={`showPrevLogsPage`}
                  tooltipTextKey={`tooltip-inbox-show-previous-page`}
                >
                  <div className="arrow-container" onClick={decreasePage}>
                    <Icon
                      name={`arrow-${
                        getDirection() === "rtl" ? "right" : "left"
                      }`}
                      gray
                    />
                  </div>
                </Tooltip>
                <Tooltip
                  id={`showNextLogsPage}`}
                  tooltipTextKey={`tooltip-inbox-show-next-page`}
                >
                  <div className="arrow-container" onClick={increasePage}>
                    <Icon
                      name={`arrow-${
                        getDirection() === "rtl" ? "left" : "right"
                      }`}
                      gray
                    />
                  </div>
                </Tooltip>
              </div>
            ) : null}
          </div>
        </>
      )}
    </div>
  );
};

export default DownloadLogModal;
